import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import ProfessionalUnitExperiencedTiles from '../../Parts/ProfessionalUnitExperiencedTiles';
import ProfessionalUnitSectionTitle from '../../Parts/ProfessionalUnitSectionTitle';
const ProfessionalUnitExperiencedHeader = () => (_jsxs("div", Object.assign({ className: 'experienced_header' }, { children: [_jsx(ProfessionalUnitSectionTitle, { title: '経験豊富な業界・テーマ' }), _jsx(ProfessionalUnitExperiencedTiles, {})] })));
export default ProfessionalUnitExperiencedHeader;
